import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "./Login";

export default function AcceptInvite() {
    const [sp] = useSearchParams();
    const [form, setForm] = useState({ token: sp.get("token") || "", first_name: "", last_name: "", password: "" });
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/accept-invite", form);
            localStorage.setItem("bdo_access", data.access_token);
            localStorage.setItem("bdo_refresh", data.refresh_token);
            toast.success("Welcome to the team");
            nav("/app/dashboard");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Invite failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell testid="page-accept-invite" title="Accept invitation" sub="Complete your profile to join your team.">
            <form onSubmit={submit} className="space-y-5" data-testid="accept-invite-form">
                <div>
                    <Label htmlFor="token">Invite token</Label>
                    <Input id="token" value={form.token} onChange={(e) => set("token", e.target.value)} required className="mt-2 font-mono text-xs" data-testid="invite-token" />
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <Label htmlFor="first">First name</Label>
                        <Input id="first" value={form.first_name} onChange={(e) => set("first_name", e.target.value)} required className="mt-2" data-testid="invite-first" />
                    </div>
                    <div>
                        <Label htmlFor="last">Last name</Label>
                        <Input id="last" value={form.last_name} onChange={(e) => set("last_name", e.target.value)} required className="mt-2" data-testid="invite-last" />
                    </div>
                </div>
                <div>
                    <Label htmlFor="password">Password</Label>
                    <Input id="password" type="password" value={form.password} onChange={(e) => set("password", e.target.value)} required minLength={8} className="mt-2" data-testid="invite-password" />
                </div>
                <button type="submit" disabled={loading} className="w-full bg-navy text-arch-white px-6 py-3 text-sm hover:opacity-90 disabled:opacity-50" data-testid="invite-submit">
                    {loading ? "Joining…" : "Accept & join"}
                </button>
            </form>
        </AuthShell>
    );
}
